import { useEffect, useRef } from 'react';
import { ref, onValue } from 'firebase/database';
import { db } from 'utils/firebase-config';

/**
 * Subscribe to the News real-time signal. `onUpdate` fires when news is
 * published/updated — a manual admin save (immediate) or once per scrape run —
 * debounced so a burst of signals coalesces into a single refetch. Skips the
 * initial value on subscribe. No toast.
 */
export function useNewsRealtime(onUpdate: () => void, debounceMs = 800): void {
  const cbRef = useRef(onUpdate);
  cbRef.current = onUpdate;

  useEffect(() => {
    const signalRef = ref(db, 'newsUpdates/lastPublishedAt');
    let first = true;
    let timer: ReturnType<typeof setTimeout> | null = null;

    const unsubscribe = onValue(signalRef, () => {
      if (first) {
        first = false;
        return;
      }
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => cbRef.current(), debounceMs);
    });

    return () => {
      if (timer) clearTimeout(timer);
      unsubscribe();
    };
  }, [debounceMs]);
}
